/**
 * Competition titles from API: `nameHe`, `nameEn`, with legacy `name` fallback.
 * @param {{ name?: string, nameHe?: string, nameEn?: string, slug?: string } | null | undefined} c
 * @param {'en' | 'he'} language
 */
export function getCompetitionDisplayName(c, language) {
  if (!c) return '';
  const legacy = typeof c.name === 'string' ? c.name.trim() : '';
  if (language === 'en') {
    const en = typeof c.nameEn === 'string' ? c.nameEn.trim() : '';
    return en || legacy || String(c.slug || '').trim() || '';
  }
  const he = typeof c.nameHe === 'string' ? c.nameHe.trim() : '';
  return he || legacy || String(c.slug || '').trim() || '';
}

/** Other locale’s name for subtitles (admin list, etc.). */
export function getCompetitionAltName(c, language) {
  if (!c) return '';
  if (language === 'en') {
    const he = typeof c.nameHe === 'string' ? c.nameHe.trim() : '';
    return he;
  }
  const en = typeof c.nameEn === 'string' ? c.nameEn.trim() : '';
  return en;
}
